export default "__VITE_ASSET__DYyBoxpm__"